module.exports = __webpack_public_path__ + "img/breakwater.a3e1d491.svg";